var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7603 10.1901L11.08 2.389C10.4657 1.36537 9.52597 0.779541 8.49997 0.779541C7.47397 0.779541 6.53426 1.36537 5.91993 2.38742L1.23959 10.1901C0.617345 11.2264 0.549262 12.3315 1.05355 13.2222C1.55705 14.1136 2.5403 14.625 3.74997 14.625H13.25C14.4596 14.625 15.4429 14.1136 15.9464 13.223C16.4507 12.3323 16.3826 11.2272 15.7603 10.1901ZM8.49997 11.893C7.82389 11.893 7.27289 11.3427 7.27289 10.6667C7.27289 9.98979 7.82309 9.43879 8.49997 9.43879C9.17684 9.43879 9.72705 9.98979 9.72705 10.6667C9.72705 11.3427 9.17605 11.893 8.49997 11.893ZM9.79276 6.01562C9.78405 6.04017 8.68364 8.76113 8.68364 8.76113C8.65355 8.83554 8.58072 8.88462 8.50076 8.88462C8.4208 8.88462 8.34797 8.83554 8.31789 8.76113L7.21668 6.03937C7.14543 5.85492 7.11455 5.68867 7.11455 5.52083C7.11455 4.75687 7.73601 4.13542 8.49997 4.13542C9.26393 4.13542 9.88539 4.75687 9.88539 5.52083C9.88539 5.68867 9.85451 5.85492 9.79276 6.01562Z",
    fill: "#FBB040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.fd336b5ce2e3da5ff2c9db91fe060218.svg";
export { ForwardRef as ReactComponent };